export default __webpack_public_path__ + "static/media/IsuriKarunaratne.51f85477.jpg";